module.exports = __webpack_public_path__ + "media/LandingPageAssets/PlusIcon-c7fe3822.svg";